<div class="grid" *ngIf="carInformacionInicial">
  <div class="col-12 md:col-12 lg:col-12 text-center">
    <i class="fa fa-refresh fa-spin fa-3x fa-fw"></i><br>
    <span>{{'LBL_CONSULTANDO' | translate }}</span>
  </div>
</div>
<div *ngIf="!carInformacionInicial">
  <div class="grid">
    <div class="col-6" *ngIf="!visualizar">
      <button type="button" pButton (click)="agregarNuevoGrupo()"
              label="{{ 'PRODUCTOSALERTA.BTN_AGREGARGRUPOCONDICIONES' | translate}}"></button>
    </div>
  </div>
  <div class="grid" *ngIf="listaAlertaGrupos.length > 0" style="max-height: 400px;overflow-y: auto;">
    <div class="col-12" *ngFor="let g of listaAlertaGrupos;let i = index;">
      <div *ngIf="g.indicadorHabilitado">
        <p-panel >
          <p-header>
            <div>
              <label>{{g.codigo ? g.codigo : 'Sin código'}}</label>
              <!--{{ 'PRODUCTOSALERTA.LBL_EDITARGRUPO' | translate }}-->
              <span style="margin-left:10px;" *ngIf="!visualizar">
              <i class="fa fa-pencil" style="cursor:pointer;" (click)="editarGrupo(g.idProductoAlertaGrupo)"></i>
            </span>
            </div>
          </p-header>

          <div *ngIf="g.productosAlertasGruposCondiciones.length > 0">
            <div class="grid">
              <div class="col-12 md:col-12 lg:col-12">
                <p-table  #dt
                          selectionMode="single"
                          [columns]="columnas" [loading]="buscando"
                          [value]="g.productosAlertasGruposCondiciones"
                          [paginator]="false" >
                  <ng-template pTemplate="header" let-columns>
                    <tr>
                      <th *ngFor="let col of columns" [pSortableColumn]="col.field" [pSortableColumnDisabled]="!col.sort" class="text-center">
                        {{col.header}}
                        <p-sortIcon [field]="col.field" *ngIf="col.sort"></p-sortIcon>
                      </th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-row>
                    <tr [pSelectableRow]="row" *ngIf="row.indicadorHabilitado">
                      <td class="text-center">{{row.nombreCondicion}}</td>
                      <td class="text-center">{{row.nombreTipoValorCondicion}}</td>
                      <td class="text-center">
                        <label *ngIf="row.codigoTipoValorCampo.toLowerCase() === 'smlv' || row.codigoTipoValorCampo.toLowerCase() === 'nume'">{{row.valorCondicion}}</label>
                        <label *ngIf="row.codigoTipoValorCampo.toLowerCase() === 'porc'">{{row.valorCondicion}} %</label>
                        <label *ngIf="row.codigoTipoValorCampo.toLowerCase() === 'peso'">{{row.valorCondicion | dinero}}</label>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage" let-columns>
                    <tr>
                      <td [attr.colspan]="columns.length" class="text-center">
                        {{ 'MSG_NOHAYREGISTROS' | translate}}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </div>
          <div *ngIf="g.productosAlertasGruposCondiciones.length === 0">
            <div class="grid">
              <div class="col-12 text-center">
                <h2>{{ 'PRODUCTOSALERTA.MSG_NOEXISTENCONDICIONES' | translate }}</h2>
              </div>
            </div>
          </div>
        </p-panel>
      </div>
    </div>
  </div>
  <div class="grid" *ngIf="listaAlertaGrupos.length === 0">
    <div class="col-12 text-center">
      <h2>{{ 'PRODUCTOSALERTA.MSG_NOEXISTENGRUPOSCONDICIONES' | translate }}</h2>
    </div>
  </div>
</div>

<p-dialog id="dlgAgregarCondiciones"
          [draggable]="false"
          [resizable]="false"
          [closable]="false"

          [contentStyle]="{'width':'800px'}"
          [(visible)]="showDlgCondiciones"
          *ngIf="showDlgCondiciones"
          [modal]="true">

  <p-header>
    {{ 'PRODUCTOSALERTA.LBL_CONDICIONESGRUPO' | translate }}
  </p-header>

  <div class="grid form-group">
    <div class="col-12 md:col-12 lg:col-12">
      <div class="grid">
        <div class="col-2 md:col-2 lg:col-2" *ngIf="!productoGrupo">
          <div class="div-form">
            <label><strong>*{{ 'PRODUCTOSALERTA.LBL_CODIGOGRUPO' | translate}} :</strong></label>
          </div>
        </div>
        <div class="col-3 md:col-3 lg:col-3" *ngIf="!productoGrupo">
          <div class="div-form">
            <input type="text" pInputText id="codigoGrupo"
                   name="codigoGrupo" [maxlength]="6"
                   autocomplete="off" codigos
                   [(ngModel)]="codigoGrupo">
            <div class="p-message p-messages-error p-corner-all" *ngIf="grupoSubmitted && !codigoGrupo">
              {{ 'PRODUCTOSALERTA.LBL_CODIGOGRUPO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
            </div>
          </div>
        </div>
        <div class="col-3 md:col-3 lg:col-3" *ngIf="productoGrupo">
          <div class="div-form">
            <label class="falso-combo-texto"><strong>*{{ 'PRODUCTOSALERTA.LBL_CODIGOGRUPO' | translate}} : {{productoGrupo.codigo ? productoGrupo.codigo : 'Sin código'}}</strong></label>
          </div>
        </div>
      </div>
    </div>
    <div class="col-12 md:col-12 lg:col-12">
      <button  *ngIf="!formCondiciones.validando" icon="fa fa-plus" label="{{'PRODUCTOSALERTA.BTN_AGREGARCONDICIONES' | translate }}"
              pButton class="p-button-success" (click)="agregarCondicion()"></button>
    </div>
    <div class="col-12 md:col-12 lg:col-12" style="max-height: 600px;overflow-y: auto;">
      <p-panel >
        <p-header>
          <div class="grid">
            <div class="col-3 text-center">
              <label><strong>{{ 'PRODUCTOSALERTA.LBL_OPERADOR' | translate}}</strong></label>
            </div>
            <div class="col-4 text-center">
              <label><strong>{{ 'PRODUCTOSALERTA.LBL_TIPOCAMPO' | translate}}</strong></label>
            </div>
            <div class="col-3 text-center">
              <label><strong>{{ 'PRODUCTOSALERTA.LBL_VALOR' | translate}}</strong></label>
            </div>
            <div class="col-2 text-center">
              <label><strong>{{ 'PRODUCTOSALERTA.LBL_ACCIONES' | translate}}</strong></label>
            </div>
          </div>
        </p-header>
        <div *ngIf="formCondiciones.listaCondicionesAgregar.length > 0">
          <div *ngFor="let c of formCondiciones.listaCondicionesAgregar; let i = index;">
            <div class="grid" *ngIf="c.indicadorHabilitado">
              <div class="col-3">
                <div class="div-form">
                  <p-dropdown disableTab  id="idCondicion" name="idCondicion" [options]="listaCondiciones"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter" required #lisCondiciones="ngModel"
                               [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].idCondicion"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && !formCondiciones.listaCondicionesAgregar[i].idCondicion">
                    {{ 'PRODUCTOSALERTA.LBL_OPERADOR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-4">
                <div class="div-form">
                  <p-dropdown disableTab  id="idTipoCampo" name="idTipoCampo" [options]="listaTiposCampo" optionLabel="nombre"
                              placeholder="{{ 'LBL_SELECCIONE' | translate}}" filter="filter" required #lisTiposCampo="ngModel"
                               [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].objTipoCampoValor" (onChange)="cambiarInputValor($event.value, i)"
                  ></p-dropdown>
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && !formCondiciones.listaCondicionesAgregar[i].idTipoValorCampo">
                    {{ 'PRODUCTOSALERTA.LBL_TIPOCAMPO' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>

              <div class="col-3" *ngIf="c.codigoTipoCampo && c.codigoTipoCampo.toLowerCase() === 'smlv'">
                <div class="div-form">
                  <input type="number" pInputText id="valorCondicionSMV"
                         name="valorCondicionSMV" [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].valorCondicion"
                         maxlength="9" numero-decimal-reactive [decimales]="6" [minimo]="0" [entero]="3">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && formCondiciones.listaCondicionesAgregar[i].valorCondicion === null">
                    {{ 'PRODUCTOSALERTA.LBL_VALOR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-3" *ngIf="c.codigoTipoCampo && c.codigoTipoCampo.toLowerCase() === 'porc'">
                <div class="div-form">
                  <input type="text" pInputText id="valorCondicionPorc"
                         name="valorCondicionPorc" [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].valorCondicion"
                         maxlength="9" porcentaje-reactive [decimales]="6" [maximo]="200">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && formCondiciones.listaCondicionesAgregar[i].valorCondicion === null">
                    {{ 'PRODUCTOSALERTA.LBL_VALOR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-3" *ngIf="c.codigoTipoCampo && c.codigoTipoCampo.toLowerCase() === 'nume'">
                <div class="div-form">
                  <input type="text" pInputText id="valorCondicionNum"
                         name="valorCondicionNum" [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].valorCondicion"
                         maxlength="18"
                         currencyMask
                         [options]="{ prefix: '$', thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0, nullable: true }">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && formCondiciones.listaCondicionesAgregar[i].valorCondicion === null">
                    {{ 'PRODUCTOSALERTA.LBL_VALOR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-3" *ngIf="c.codigoTipoCampo && c.codigoTipoCampo.toLowerCase() === 'peso'">
                <div class="div-form">
                  <input type="text" pInputText id="valorCondicionPeso"
                         name="valorCondicionPeso" [(ngModel)]="formCondiciones.listaCondicionesAgregar[i].valorCondicion"
                         maxlength="18"
                         currencyMask
                         [options]="{ prefix: '$ ',  thousands: appSettingService.separadorMiles, decimal: appSettingService.separadorDecimales, align: 'left', allowNegative:false, precision : 0, nullable: true }">
                  <div class="p-message p-messages-error p-corner-all" *ngIf="formCondiciones.validandoCondiciones && formCondiciones.listaCondicionesAgregar[i].valorCondicion === null">
                    {{ 'PRODUCTOSALERTA.LBL_VALOR' | translate }} {{ 'LBL_REQUERIDO' | translate }}
                  </div>
                </div>
              </div>
              <div class="col-2 text-center" [hidden]="formCondiciones.condicionesSubmitted">
                <i class="fa fa-trash" style="color:red;cursor: pointer;" (click)="eliminarCondicion(i)"></i>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="formCondiciones.listaCondicionesAgregar.length === 0">
          <div class="grid">
            <div class="col-12 text-center">
              <h2>{{ 'PRODUCTOSALERTA.MSG_NOEXISTENCONDICIONES' | translate }}</h2>
            </div>
          </div>
        </div>
        <div class="grid form-footer-buttons">
          <div class="form-group col-12" *ngIf="!formCondiciones.condicionesSubmitted">
            <a (click)="cerrarDialogoCondiciones()" class="cancelar">{{'BTN_CANCELAR' | translate }}</a>
            <button icon="fa fa-check-circle" label="{{'PRODUCTOSALERTA.BTN_GUARDARCONDICIONES' | translate }}"
                    pButton class="p-button-success" (click)="onSubmit()"></button>
          </div>
          <div class="col-12 md:col-12 lg:col-12 text-center" *ngIf="formCondiciones.condicionesSubmitted">
            <i class="fa fa-refresh fa-spin fa-2x fa-fw"></i><br>
            <span>{{'LBL_PROCESANDO' | translate }}</span>
          </div>
        </div>
      </p-panel>
    </div>
  </div>
</p-dialog>
